import { TranslateService } from '../../../api/translate.service';
import { Injectable } from '@angular/core';
import { 
  fieldAddressLine1Col, 
  fieldAmountCol, 
  fieldCounterPartyCol, 
  fieldCustomerNameCol, 
  fieldDateCol, 
  fieldIdCol, 
  fieldInvoiceIdCol, 
  fieldIpMetroCol, 
  fieldOpportunityCol, 
  fieldPrimaryEmployeeNameCol, 
  fieldPropertyAreaCol, 
  fieldPropertyBaseIdCol, 
  fieldSellerNameCol, 
  fieldTransactionTypeCol
} from '../../../utils/ag-grid/column-defs';
import { ColDef } from 'ag-grid-community';

@Injectable({
    providedIn: 'root'
  })
export class YTDSummaryReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
        key: 'producer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OTHER_PARTY'),
        key: 'other_party',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_AREA'),
        key: 'size',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_FEE_$'),
        key: 'cbre_fee_total',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_REVENUE_FUMO'),
        key: 'cbre_revenue_fumo_balance',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SELLER_NAME'),
        key: 'seller_name', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_BASE_ID'),
        key: 'property_base_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IP_METRO'), 
        key: 'ip_metro', 
        width: 30,
        style: { ...settings.middle }
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      }, 
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },  
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },      
      {
        ...fieldOpportunityCol,
        minWidth: 250,
        headerName: this.translateService.getTranslation('OPPORTUNITY'),
      },            
      {
        ...fieldPrimaryEmployeeNameCol,
        field: 'producer_name',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
      },      
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        minWidth: 250,
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },       
      {
        ...fieldCounterPartyCol,
        field: 'other_party',
        headerName: this.translateService.getTranslation('OTHER_PARTY'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },     
      {
        ...fieldPropertyAreaCol,
        field: 'size',
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },
      {
        ...fieldAmountCol,
        field: 'cbre_fee_total',
        headerName: this.translateService.getTranslation('CBRE_FEE_$'),
      },
      {
        ...fieldAmountCol,
        field: 'cbre_revenue_fumo_balance',
        minWidth: 270,
        headerName: this.translateService.getTranslation('CBRE_REVENUE_FUMO'),
      },
      {
        ...fieldSellerNameCol,
        headerName: this.translateService.getTranslation('SELLER_NAME'),
      },
      {
        ...fieldPropertyBaseIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      },
      {
        ...fieldIpMetroCol,
        headerName: this.translateService.getTranslation('IP_METRO'),
      },
    ];
  }
}
